module.exports = __webpack_public_path__ + "static/img/product_images_05_h5_zh.a1baa41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_05_h5_zh.png
// module id = GGu2
// module chunks = 34